import { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";
import { currencySymbol } from "@/lib/api";

/**
 * Smoothly tweens a number when the value changes.
 * Usage: <AnimatedNumber value={123.45} currency="USD" />
 */
export const AnimatedNumber = ({ value = 0, currency, className = "", withSign = false, duration = 0.6 }) => {
  const [display, setDisplay] = useState(value);
  const prevRef = useRef(value);

  useEffect(() => {
    const controls = animate(prevRef.current, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(v),
    });
    prevRef.current = value;
    return () => controls.stop();
  }, [value, duration]);

  const sym = currency ? currencySymbol(currency) : "";
  // Snap any value within ±0.005 to a clean zero, eliminating "-$0.00" displays
  const rounded = Math.round(display * 100) / 100;
  const isZero = Math.abs(rounded) < 0.005;
  const abs = isZero ? 0 : Math.abs(rounded);
  const sign = isZero ? "" : withSign ? (rounded > 0 ? "+" : "-") : (rounded < 0 ? "-" : "");
  return (
    <span className={`font-mono tabular-nums ${className}`}>
      {sign}{sym}{abs.toFixed(2)}
    </span>
  );
};
